import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
/* Font 설정 */
html, body, #root {
  font-family: 'SUITE', 'SUITE Variable', sans-serif;
  background-color: ${(props) => props.theme.bgColor};
}

/* reset CSS */
html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed, 
figure, figcaption, footer, header, hgroup, 
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure, 
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;

}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}

:root {
        --primary-color: #045ADC;
        --point-color: #045ADC;
				--button-color: #FAFAFA;
				--button-border-color: #CCCCCC;
				--button-hover-color:  rgba(4, 90, 220, 0.5);
				--point-opacity: 50%;
        --font-reqular: 1rem;
        --font-small: 0.8rem;
        --primary-margin: 1.25rem;
				--darkmode-color: ${(props) => props.theme.color};
				--darkmode-bgColor: ${(props) => props.theme.bgColor};
    }
`;

export default GlobalStyles;
